import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OAUTH_BASE_URL } from "../api/axiosInstance";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");
    if (code) {
      navigate(`/login/callback?code=${code}`, { replace: true });
    }
  }, [navigate]);

  const handleGoogleLogin = () => {
    window.location.href = `${OAUTH_BASE_URL}/admin/oauth2/authorization/google`;
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Knollo Console</h1>
        <p style={styles.subtitle}>관리자 콘솔</p>
        <button style={styles.button} onClick={handleGoogleLogin}>
          <img
            src="https://www.google.com/favicon.ico"
            alt="Google"
            style={styles.googleIcon}
          />
          Google로 로그인
        </button>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "#1a1a2e",
  },
  card: {
    background: "#16213e",
    borderRadius: 12,
    padding: "48px 40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 16,
    boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
    minWidth: 320,
  },
  title: {
    color: "#4fc3f7",
    fontSize: 28,
    fontWeight: 700,
    margin: 0,
    letterSpacing: 2,
  },
  subtitle: {
    color: "#94a3b8",
    fontSize: 14,
    margin: 0,
  },
  button: {
    marginTop: 16,
    display: "flex",
    alignItems: "center",
    gap: 10,
    background: "#fff",
    color: "#333",
    border: "none",
    borderRadius: 8,
    padding: "12px 24px",
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
    width: "100%",
    justifyContent: "center",
  },
  googleIcon: {
    width: 18,
    height: 18,
  },
};

export default LoginPage;
